module.exports = __webpack_public_path__ + "img/group-2990@3x.4012762b.jpg";